import jsonData from './filters.json';
import WebsiteService from '@/services/website';

export const filters = () => {
    const filters = {};

    jsonData.forEach(data => {
        const symbol = data.title.slice(0, 2);
        const pathTitle = data.title.replace(/\W/g, '');
        const categories = groups.filter(g => g.symbols.some(s => data.title.indexOf(s) !== -1));

        if (data.title.length && categories.length) {
            categories.forEach(c => {
                const category = c.group;

                if (filters[category] === undefined) {
                    filters[category] = {};
                }

                if (filters[category][symbol] === undefined) {
                    filters[category][symbol] = [];
                }

                const existed = filters[category][symbol].find(i => i.title === data.title);

                if (existed) return;

                filters[category][symbol].push({
                    title: data.title,
                    permalink: data.permalink,
                    slug: data.title.toLowerCase(),
                    color: data.color,
                    range: data.range,
                    jsonPath: WebsiteService.getCurvePath(pathTitle),
                });
            });
        }
    });

    return filters;
};


export const groups = [
    {
        group: 'Bandpass',
        symbols: ['BP', 'BN', 'Bi', 'PE']
    },
    {
        group: 'Multi Bandpass',
        symbols: ['DB', 'TB']
    },
    {
        group: 'Longpass',
        symbols: ['LP']
    },
    {
        group: 'Shortpass',
        symbols: ['SP']
    },
    {
        group: 'Neutral Density',
        symbols: ['ND', 'Ni']
    },
    {
        group: 'Polarizing',
        symbols: ['PS', 'PR', 'PA']
    },
    {
        group: 'Protective',
        symbols: ['AC', 'LP17', 'LP2', 'LP3', 'LP415', 'LP418']
    },
    {
        group: 'Acrylic',
        symbols: ['AB', 'AC']
    },
    {
        group: 'Light Balancing',
        symbols: ['LA']
    },
    // {
    //     group: 'Diffuser',
    //     symbols: ['DF']
    // },
];

export default filters();